function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import _ from 'underscore';
import React, { createRef, useState, useEffect, useCallback } from 'react';
import './svgExporter'; // create handlers for SVG and PNG download buttons
import CollapsePreferences from './collapse_preferences';
import useDetectPrint from "react-detect-print";

// Grapher is a function that takes a Graph class and returns a React component.
// This React component provides HTML boilerplate to add heading, to make the
// graphs collapsible, to redraw graphs when window is resized, and SVG and PNG
// export buttons and functionality.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Grapher(Graph) {
  return function Component(props) {
    var alwaysShowName = Graph.alwaysShowName === undefined ? false : Graph.alwaysShowName();
    var printing = useDetectPrint();
    var name = Graph.name(props);
    var _useState = useState(window.innerWidth),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];
    var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      collapsed = _useState4[0],
      setCollapsed = _useState4[1];
    var svgContainerRef = /*#__PURE__*/createRef();
    var graph = null;
    var graphId = function graphId() {
      return Graph.graphId(props);
    };
    var graphLinksJSX = function graphLinksJSX() {
      return /*#__PURE__*/_jsxs("div", {
        className: "hit-links float-right text-right text-blue-300 h-4 print:hidden",
        children: [/*#__PURE__*/_jsxs("a", {
          href: "#",
          className: "btn-link text-sm text-seqblue hover:text-seqorange cursor-pointer export-to-svg",
          children: [/*#__PURE__*/_jsx("i", {
            className: "fa fa-download"
          }), " SVG"]
        }), /*#__PURE__*/_jsx("span", {
          className: "line px-1",
          children: "|"
        }), /*#__PURE__*/_jsxs("a", {
          href: "#",
          className: "btn-link text-sm text-seqblue hover:text-seqorange cursor-pointer export-to-png",
          children: [/*#__PURE__*/_jsx("i", {
            className: "fa fa-download"
          }), " PNG"]
        })]
      });
    };
    var header = function header() {
      if (Graph.canCollapse()) {
        return /*#__PURE__*/_jsxs("div", {
          className: "grapher-header pr-px",
          children: [/*#__PURE__*/_jsxs("h4", {
            className: "inline-block pl-px m-0 caption cursor-pointer text-sm",
            onClick: function onClick() {
              return collapsePreferences.toggleCollapse();
            },
            children: [collapsePreferences.renderCollapseIcon(), /*#__PURE__*/_jsx("span", {
              className: "print:hidden",
              children: "\xA0"
            }), Graph.name(props)]
          }), !collapsed && graphLinksJSX()]
        });
      } else if (alwaysShowName) {
        return /*#__PURE__*/_jsxs("div", {
          className: "grapher-histogram-header",
          style: {
            position: 'relative'
          },
          children: [/*#__PURE__*/_jsxs("h4", {
            className: "caption",
            children: ["\xA0", Graph.name(props)]
          }), /*#__PURE__*/_jsx("div", {
            className: "pull-right",
            style: {
              position: 'absolute',
              top: 0,
              right: 0
            },
            children: !collapsed && graphLinksJSX()
          })]
        });
      } else {
        return /*#__PURE__*/_jsx("div", {
          className: "pr-px",
          children: !collapsed && graphLinksJSX()
        });
      }
    };
    var svgContainerJSX = function svgContainerJSX() {
      var cssClasses = Graph.className() + ' svg-container hidden';
      if (!collapsed) cssClasses += ' !block';
      return /*#__PURE__*/_jsx("div", {
        ref: svgContainerRef,
        id: graphId(),
        className: cssClasses
      });
    };
    var svgContainer = function svgContainer() {
      return $(svgContainerRef.current);
    };
    var draw = function draw() {
      var printing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var graphWidth = 'auto';
      if (printing) graphWidth = '900';
      // Clean slate.
      svgContainer().empty();
      graph = null;

      // Draw if uncollapsed.
      if (collapsed) return;
      svgContainer().width(graphWidth);
      graph = new Graph(svgContainer(), props);
      svgContainer().find('svg').attr('data-name', Graph.dataName(props));
    };
    useEffect(function () {
      // Attach a debounced listener to handle window resize events 
      // Updates the width state with the current window width, throttled to run at most once every 125ms
      var handleResize = _.debounce(function () {
        return setWidth(window.innerWidth);
      }, 125);
      window.addEventListener("resize", handleResize);
      var isCollapsed = collapsePreferences.preferenceStoredAsCollapsed();
      setCollapsed(Graph.canCollapse() && (props.collapsed || isCollapsed));
      draw();
      return function () {
        return window.removeEventListener("resize", handleResize);
      };
    }, []);
    useEffect(function () {
      draw(printing);
    }, [printing, width]);
    var setState = function setState(state) {
      setCollapsed(state.collapsed);
    };
    var collapsePreferences = new CollapsePreferences({
      name: name,
      state: {
        collapsed: collapsed
      },
      setState: setState
    });
    if (Graph.name(props) === null) {
      return null;
    } else {
      var printCss = collapsed ? 'print:hidden' : '';
      var cssClasses = Graph.className() + ' grapher' + printCss;
      return /*#__PURE__*/_jsxs("div", {
        className: cssClasses,
        children: [header(), svgContainerJSX()]
      });
    }
  };
}